import React from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18next';

import { Typo } from 'uikit/content';

import VideoEnrollButton from './videoEnrollButton';

import styles from '../styles/videoContentSchedule.module.scss';

const VideoContentSchedule = ({
  endAt = '',
  enrollmentStatus,
  isSettingEnrollmentStatus,
  setEnrollmentStatus,
  speakers = [],
  startAt = '',
  waitlistSpot,
  waitlistTotal,
}) => {
  const { lang = 'en' } = document.documentElement;
  const startDate = new Date(startAt);
  const endDate = new Date(endAt);

  const getRange = () => {
    const getDateTimeString = (date) =>
      date.toLocaleString(lang, { dateStyle: 'medium', timeStyle: 'short' });

    const getTimeString = (date) => date.toLocaleString(lang, { timeStyle: 'short' });

    return startDate.toDateString() === endDate.toDateString()
      ? `${getDateTimeString(startDate)} – ${getTimeString(endDate)}`
      : `${getDateTimeString(startDate)} – ${getDateTimeString(endDate)}`;
  };

  return (
    <div className={styles.container}>
      <div className={styles.element}>
        <div>
          <Typo className={styles.month} modifier="uppercase" variant="s01" weight="medium">
            {startDate.toLocaleString(lang, { month: 'short' })}
          </Typo>
          <Typo className={styles.day} variant="d05">
            {startDate.toLocaleString(lang, { day: 'numeric' })}
          </Typo>
        </div>
        <div>
          <Typo variant="d01">{getRange()}</Typo>
          {Boolean(speakers?.length) && (
            <Typo color="secondary" variant="s01">
              {i18n.t('speakers-list', {
                speakers: speakers.map(({ name }) => name).join(', '),
              })}
            </Typo>
          )}
        </div>
      </div>
      <VideoEnrollButton
        enrollmentStatus={enrollmentStatus}
        isLive={Date.now() >= startDate.getTime()}
        isSettingEnrollmentStatus={isSettingEnrollmentStatus}
        setEnrollmentStatus={setEnrollmentStatus}
        waitlistSpot={waitlistSpot}
        waitlistTotal={waitlistTotal}
      />
    </div>
  );
};

VideoContentSchedule.propTypes = {
  endAt: PropTypes.string,
  speakers: PropTypes.arrayOf(PropTypes.shape({ name: PropTypes.string })),
  startAt: PropTypes.string,
};

export default React.memo(VideoContentSchedule);
